import { realityId } from "@/utils/reality-id";
import api from "../api";
import { RealityInfo } from "./types/reality.types";

export const getRealityInfo = async (): Promise<RealityInfo> => {
  const res = await api.get<RealityInfo>(`/realities/${realityId}`);

  return res.data;
};
